import React, { forwardRef } from "react";
import { Box, BoxProps, Stack } from "../../../vanilla";
import '../../../assets/svg/clearpay-button.svg'

export const ClearpayPaymentsButton = forwardRef((props: BoxProps<React.ElementType>, ref) => {
    const { ...rest } = props
    return (
        <Stack {...rest} ref={ref}>
            <Box
                as={'svg'}
                aria-label="Clearpay button"
                style={{ width: '100%', height: '44px' }}
                display={'inline-block'}
                cursor={'pointer'}
                className="clearpay-payment-button"
            >
                <use role="presentation" xlinkHref={`#clearpay-button`} />
            </Box>
        </Stack>
    )
})